export const getClasses = (array) => array
    .filter((element) => element && element.trim().length > 0)
    .join(" ")
    .trim();
//# sourceMappingURL=getClasses.js.map